module.exports = __webpack_public_path__ + "static/media/plpic.e8b76837.png";